// The one piece of real logic in the app: derive a win-% table per player.
//
// `played` counts every appearance in a match's teams; `wins` counts every
// appearance in that match's `pointsFor`. Names now come from a fixed player
// list (dropdowns in the admin), so the two can no longer drift apart the way
// they could when teams were free-text strings.

export const cardWinner = (match) => {
  let a = 0;
  let b = 0;
  (match.games || []).forEach((g) => {
    if (g.a > g.b) a += 1;
    else if (g.b > g.a) b += 1;
  });
  if (a > b) return match.teamA || [];
  if (b > a) return match.teamB || [];
  return null; // tie -> needs a manual call
};

export const bocceWinner = (match) => {
  if (match.scoreA > match.scoreB) return match.teamA || [];
  if (match.scoreB > match.scoreA) return match.teamB || [];
  return null;
};

export const autoWinnerFor = (match, sport) =>
  (sport === 'karte' ? cardWinner(match) : bocceWinner(match)) || [];

// Winner actually credited: auto-derived unless the match is flagged as an override.
export const winnersOf = (match, sport) => {
  if (match.autoWinner === false) return match.pointsFor || [];
  return autoWinnerFor(match, sport);
};

export const getStandings = (matches, sport) => {
  const stats = {};
  const touch = (name) => {
    const n = String(name).trim();
    if (!n) return null;
    if (!stats[n]) stats[n] = { name: n, played: 0, wins: 0 };
    return stats[n];
  };

  (matches || []).forEach((match) => {
    [...(match.teamA || []), ...(match.teamB || [])].forEach((p) => {
      const s = touch(p);
      if (s) s.played += 1;
    });
    winnersOf(match, sport).forEach((p) => {
      const s = touch(p);
      if (s) s.wins += 1;
    });
  });

  return Object.values(stats)
    .map((p) => ({ ...p, percent: p.played > 0 ? (p.wins / p.played) * 100 : 0 }))
    .sort((a, b) => b.percent - a.percent || b.wins - a.wins || a.name.localeCompare(b.name, 'hr'));
};
